import { Link } from 'react-router-dom';

/**
 * O TEXTO DOS TERMOS DE USO — aprovado pelo pesquisador em 28/09/2026 (pedido de acesso,
 * commit 4). Um lugar só: a página pública `/termos` e o aceite do primeiro acesso leem daqui.
 *
 * `VERSAO` é a mesma do servidor (`services/termosDeUso.ts`, `VERSAO_DOS_TERMOS`): o aceite
 * manda a versão que MOSTROU, e o servidor recusa se não for a vigente. Mudou o texto, muda a
 * versão aqui e lá — e quem aceitou a anterior é cobrado de novo.
 *
 * A VARIANTE da demonstração troca só o item 2, com a frase aprovada.
 */
export const VERSAO_DOS_TERMOS = '2026-09-28';

export function TextoDosTermos({ demonstracao = false }: { demonstracao?: boolean }) {
  return (
    <div className="space-y-3 text-gray-700 leading-relaxed">
      <p>
        <strong>1. O acervo é compartilhado.</strong> As questões que você encontra aqui foram escritas por outros
        professores e servem às suas aulas e avaliações. Não as publique nem as divulgue fora do portal: muitas ainda
        vão ser aplicadas em provas.
      </p>
      {demonstracao ? (
        <p>
          <strong>2. Conta de demonstração.</strong> Esta é uma conta de demonstração, com dados fictícios; não
          cadastre alunos reais.
        </p>
      ) : (
        <p>
          <strong>2. Só alunos das suas turmas.</strong> Você cadastra apenas estudantes das turmas em que dá aula, e só
          com os dados que a turma precisa.
        </p>
      )}
      <p>
        <strong>3. A escola é responsável pelos dados dos seus alunos.</strong> Ao cadastrá-los aqui, você o faz em nome
        da escola e dentro do que ela autoriza.
      </p>
      <p>
        <strong>4. Privacidade.</strong> O tratamento dos dados segue a{' '}
        <Link to="/privacidade" className="text-marca-600 hover:underline">Política de Privacidade</Link>.
      </p>
    </div>
  );
}
